import type { RouteContext } from '@townsquare/router/routing-types';

import Loadable from '@townsquare/loadable';
import { teamsAppAgentsDirectoryRoute } from '@townsquare/routes/teams-app-agents-directory-view';

const TeamsAppAgentDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () => import(/* webpackChunkName: "teamsAppAgentsDirectory-view" */ './index'),
	loading: () => null,
});

teamsAppAgentsDirectoryRoute.component = TeamsAppAgentDirectoryLoadable;
export const teamsAppAgentsDirectoryRouterRoute = teamsAppAgentsDirectoryRoute;
